var React = require('react');

function ArrowLinkRightInline (props) {
    return React.createElement("g",props,React.createElement("polygon",{"points":"10.62 0 14.02 3.4 10.62 6.79 8.23 6.79 10.63 4.39 0 4.39 0 2.4 10.62 2.4 8.23 0 10.62 0"}));
}

ArrowLinkRightInline.defaultProps = {"transform":"translate(5, 6)"};

module.exports = ArrowLinkRightInline;

ArrowLinkRightInline.default = ArrowLinkRightInline;
